var _g, _g2, _g3, _rect, _path, _rect2, _path2, _rect3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersistenceExercise(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 144,
    viewBox: "0 0 288 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11356_10833)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3335 41.6667C32.3335 40.1939 33.5274 39 35.0001 39H42.9997H51.0001C52.4729 39 53.6668 40.1939 53.6668 41.6667C53.6668 43.1394 52.4729 44.3333 51.0001 44.3333H45.6664V49.7986C50.5256 50.281 55.001 52.0679 58.7376 54.804L62.7706 50.771L60.8853 48.8858C59.8439 47.8444 59.8439 46.156 60.8853 45.1146C61.9267 44.0732 63.6152 44.0732 64.6566 45.1146L68.4251 48.8831L68.4274 48.8854L68.4298 48.8878L72.1991 52.6571C73.2404 53.6985 73.2404 55.3869 72.1991 56.4283C71.1577 57.4697 69.4692 57.4697 68.4278 56.4283L66.5418 54.5423L62.7111 58.373C67.0317 63.1121 69.6663 69.4152 69.6663 76.3336C69.6663 91.0612 57.7273 103 42.9997 103C28.2721 103 16.333 91.0612 16.333 76.3336C16.333 62.506 26.8575 51.1365 40.3331 49.7986V44.3333H35.0001C33.5274 44.3333 32.3335 43.1394 32.3335 41.6667ZM64.333 76.3336C64.333 88.1157 54.7818 97.6669 42.9997 97.6669C31.2176 97.6669 21.6663 88.1157 21.6663 76.3336C21.6663 64.5515 31.2176 55.0003 42.9997 55.0003C54.7818 55.0003 64.333 64.5515 64.333 76.3336Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.0007,
    cy: 76.3327,
    r: 26.6667,
    fill: "#FFF1CD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9997 97.667C54.7818 97.667 64.333 88.1157 64.333 76.3337C64.333 64.5516 54.7818 55.0003 42.9997 55.0003C31.2176 55.0003 21.6663 64.5516 21.6663 76.3337C21.6663 88.1157 31.2176 97.667 42.9997 97.667ZM42.9997 103C57.7273 103 69.6663 91.0613 69.6663 76.3337C69.6663 61.6061 57.7273 49.667 42.9997 49.667C28.2721 49.667 16.333 61.6061 16.333 76.3337C16.333 91.0613 28.2721 103 42.9997 103Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1141 66.4484C34.1555 65.407 35.844 65.407 36.8854 66.4484L44.8854 74.4484C45.9268 75.4898 45.9268 77.1782 44.8854 78.2196C43.844 79.261 42.1555 79.261 41.1141 78.2196L33.1141 70.2196C32.0727 69.1782 32.0727 67.4898 33.1141 66.4484Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.9993,
    cy: 76.3327,
    r: 2.66667,
    transform: "rotate(-90 42.9993 76.3327)",
    stroke: "#24284E",
    strokeWidth: 5.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11356_10833)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.333 41.6667C128.333 40.1939 129.527 39 131 39H139H147C148.473 39 149.667 40.1939 149.667 41.6667C149.667 43.1394 148.473 44.3333 147 44.3333H141.666V49.7986C146.526 50.281 151.001 52.0679 154.738 54.804L158.771 50.771L156.885 48.8858C155.844 47.8444 155.844 46.156 156.885 45.1146C157.927 44.0732 159.615 44.0732 160.657 45.1146L164.425 48.8831L164.427 48.8854L164.43 48.8878L168.199 52.6571C169.24 53.6985 169.24 55.3869 168.199 56.4283C167.158 57.4697 165.469 57.4697 164.428 56.4283L162.542 54.5423L158.711 58.373C163.032 63.1121 165.666 69.4152 165.666 76.3336C165.666 91.0612 153.727 103 139 103C124.272 103 112.333 91.0612 112.333 76.3336C112.333 62.506 122.858 51.1365 136.333 49.7986V44.3333H131C129.527 44.3333 128.333 43.1394 128.333 41.6667ZM160.333 76.3336C160.333 88.1157 150.782 97.6669 139 97.6669C127.218 97.6669 117.666 88.1157 117.666 76.3336C117.666 64.5515 127.218 55.0003 139 55.0003C150.782 55.0003 160.333 64.5515 160.333 76.3336Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 139.001,
    cy: 76.3327,
    r: 26.6667,
    fill: "#FFF1CD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139 97.667C150.782 97.667 160.333 88.1157 160.333 76.3337C160.333 64.5516 150.782 55.0003 139 55.0003C127.218 55.0003 117.666 64.5516 117.666 76.3337C117.666 88.1157 127.218 97.667 139 97.667ZM139 103C153.727 103 165.666 91.0613 165.666 76.3337C165.666 61.6061 153.727 49.667 139 49.667C124.272 49.667 112.333 61.6061 112.333 76.3337C112.333 91.0613 124.272 103 139 103Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.114 66.4484C130.156 65.407 131.844 65.407 132.885 66.4484L140.885 74.4484C141.927 75.4898 141.927 77.1782 140.885 78.2196C139.844 79.261 138.156 79.261 137.114 78.2196L129.114 70.2196C128.073 69.1782 128.073 67.4898 129.114 66.4484Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.999,
    cy: 76.3327,
    r: 2.66667,
    transform: "rotate(-90 138.999 76.3327)",
    stroke: "#24284E",
    strokeWidth: 5.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_11356_10833)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.667 34.3333C221.667 32.4924 223.159 31 225 31H235H245C246.841 31 248.334 32.4924 248.334 34.3333C248.334 36.1743 246.841 37.6667 245 37.6667H238.333V44.4976C244.407 45.1006 250.002 47.3342 254.673 50.7544L259.713 45.7138L257.357 43.3573C256.055 42.0555 256.055 39.945 257.357 38.6432C258.659 37.3415 260.769 37.3415 262.071 38.6432L266.784 43.3568L271.499 48.0713C272.801 49.3731 272.801 51.4836 271.499 52.7854C270.197 54.0871 268.087 54.0871 266.785 52.7854L264.427 50.4278L259.64 55.2157C265.04 61.1396 268.334 69.0184 268.334 77.6664C268.334 96.0759 253.41 111 235 111C216.591 111 201.667 96.0759 201.667 77.6664C201.667 60.3821 214.822 46.1704 231.666 44.4977V37.6667H225C223.159 37.6667 221.667 36.1743 221.667 34.3333ZM234.961 50.9998C220.251 51.0211 208.334 62.952 208.334 77.6664C208.334 92.394 220.273 104.333 235 104.333C249.728 104.333 261.667 92.394 261.667 77.6664C261.667 62.9517 249.749 51.0206 235.039 50.9998C235.026 50.9999 235.013 51 235 51C234.987 51 234.974 50.9999 234.961 50.9998Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 235,
    cy: 77.6663,
    r: 33.3333,
    fill: "#FFF1CD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235 104.333C249.728 104.333 261.667 92.3939 261.667 77.6663C261.667 62.9387 249.728 50.9997 235 50.9997C220.273 50.9997 208.334 62.9387 208.334 77.6663C208.334 92.3939 220.273 104.333 235 104.333ZM235 111C253.41 111 268.334 96.0758 268.334 77.6663C268.334 59.2569 253.41 44.333 235 44.333C216.591 44.333 201.667 59.2569 201.667 77.6663C201.667 96.0758 216.591 111 235 111Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.643 65.31C223.945 64.0082 226.055 64.0082 227.357 65.31L237.357 75.31C238.659 76.6117 238.659 78.7223 237.357 80.024C236.055 81.3258 233.945 81.3258 232.643 80.024L222.643 70.024C221.341 68.7223 221.341 66.6117 222.643 65.31Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 235,
    cy: 77.6663,
    r: 3.33333,
    transform: "rotate(-90 235 77.6663)",
    stroke: "#24284E",
    strokeWidth: 6.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 85,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163.5 101L167.5 105L174.5 97",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 85,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 101L71.5 105L78.5 97",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 249,
    y: 85,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 265,
    cy: 101,
    r: 2,
    fill: "#24284E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 257,
    cy: 101,
    r: 2,
    fill: "#24284E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 273,
    cy: 101,
    r: 2,
    fill: "#24284E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 143,
    cy: 124,
    r: 2,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 83,
    cy: 29,
    r: 2,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 124.5,
    r: 1.5,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 14.5,
    r: 1.5,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.5,
    cy: 1.5,
    r: 1.5,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.5,
    cy: 136.5,
    r: 1.5,
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 123.5,
    r: 1.5,
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 178.5,
    cy: 37.5,
    r: 1.5,
    fill: "white"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 286.5,
    cy: 35.5,
    r: 1.5,
    fill: "white"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.5,
    cy: 1.5,
    r: 1.5,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M184.5 12.5L196 27.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M265.5 7L258.5 20.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M241 128L244.5 141.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11356_10833"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(11 39)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11356_10833"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(107 39)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_11356_10833"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(195 31)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersistenceExercise);
export default __webpack_public_path__ + "static/media/persistence-exercise.3f0fc01469cfdc3f1182c56ca2751f6b.svg";
export { ForwardRef as ReactComponent };